import React from 'react';
import { Modal, Typography, Descriptions, Badge } from 'antd';
import { useTranslation } from 'react-i18next';
import { IOrg, OrgStatus, OrgStatusText } from '../../modules/orgs/interfaces';
import { format } from 'date-fns';
import GroupSelect from './GroupSelect';
import { useAppSelector } from 'hooks';
import SubGroupSelect from './SubGroupSelect';
import MachineTaskEnabled from '../Settings/MachineTaskEnabled';

const { Title } = Typography;

interface OrgModalProps {
  visible: boolean;
  onClose: () => void;
  org: IOrg | null;
}

const OrgModal: React.FC<OrgModalProps> = ({ visible, onClose, org }) => {
  const { t } = useTranslation();
  const groups = useAppSelector((state) => state.groups.groups);

  if (!org) return null;

  const getStatusBadge = (status: OrgStatus) => {
    switch (status) {
      case OrgStatus.IN_PROGRESS:
        return <Badge status="processing" text={t(OrgStatusText[1])} />;
      case OrgStatus.ACTIVE:
        return <Badge status="success" text={t(OrgStatusText[2])} />;
      case OrgStatus.INACTIVE:
        return <Badge status="error" text={t(OrgStatusText[3])} />;
      default:
        return <Badge status="default" text={t(OrgStatusText[0])} />;
    }
  };

  return (
    <Modal
      title={t('Organization Details')}
      open={visible}
      onCancel={onClose}
      footer={null}
      width={600}
    >
      <div style={{ padding: '16px 0' }}>
        <Title level={4}>{org.title}</Title>

        <Descriptions column={1} bordered>
          <Descriptions.Item label={t('ID')}>{org.id}</Descriptions.Item>

          <Descriptions.Item label={t('home.table.status')}>
            {getStatusBadge(org.status)}
          </Descriptions.Item>

          {org.createTime && (
            <Descriptions.Item label={t('home.table.createTime')}>
              {format(new Date(org.createTime.toDate()), 'dd-MM-yyyy')}
            </Descriptions.Item>
          )}

          {org.members && Array.isArray(org.members) && org.members.length > 0 && (
            <Descriptions.Item label={t('home.table.members')}>
              {org.members.length} {t('members')}
            </Descriptions.Item>
          )}

          <Descriptions.Item label={t('Gruppe')}>
            <GroupSelect groupId={org.groupId} groups={groups} orgId={org.id} />
          </Descriptions.Item>

          {org.groupId && (
            <Descriptions.Item label={t('Under gruppe')}>
              <SubGroupSelect groupId={org.groupId} orgId={org.id} />
            </Descriptions.Item>
          )}

          <Descriptions.Item label={t('Adhoc maskineopgaver')}>
            <MachineTaskEnabled orgId={org.id} />
          </Descriptions.Item>
        </Descriptions>
      </div>
    </Modal>
  );
};

export default OrgModal;
